import { Box } from "@mui/material";
import StyledDataGrid from "../../../../../components/StyledDataGrid";
import { getColumns } from "./columns";
import { getRows } from "./rows";

export default function EntitiesHealthCheckTable({
  dataByTimestamp,
  selectedTimestampIndex,
  orderedTimestamps,
}) {
  const columns = selectedTimestampIndex !== null ? getColumns() : null;

  const [rows, pinnedRows] =
    selectedTimestampIndex !== null
      ? getRows(dataByTimestamp, selectedTimestampIndex, orderedTimestamps)
      : [null, null];

  return (
    <Box width="fit-content">
      <StyledDataGrid
        columns={columns}
        rows={rows}
        getRowId={(row) => row.source}
        pageSizeOptionsOverride={[10, 20, 50]}
        pinnedRows={pinnedRows}
      />
    </Box>
  );
}
